const multibookConfig = require(`../../../package.json`).config;

let homeBookStyle = {
  bcg: require('./bcg.png'),
  multibooks: [
    {
      bcg: require('./Ikona_multibook1300.png'),
      name: 'main_book',
      title: 'Oto ja, Podręczniki',
      router: 'main_book-view',
      disable: true,
      cssStyle: {
        position: 'absolute',
        top: '-20%',
        left: '30%',
        width: '40%',
      },
    },
    {
      bcg: require('./1.png'),
      name: 'dev',
      title: 'Dev',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '10%',
        width: '20%',
      },
    },
    {
      bcg: require('./2.png'),
      name: 'informatyka',
      title: 'Informatyka',
      // disable: true,
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '30%',
        width: '20%',
      },
    },
    {
      bcg: require('./3.png'),
      name: 'otoja_kl1_1_mat',
      title: 'Oto ja, Ćwiczenia matematyczno-przyrodnicze, kl. 1, cz. 1',
      disable: true,
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '50%',
        width: '20%',
      },
    },
    {
      bcg: require('./4.png'),
      name: 'otoja_kl1_2_mat',
      title: 'Oto ja, Ćwiczenia matematyczno-przyrodnicze, kl. 1, cz. 2',
      disable: true,
      cssStyle: {
        position: 'absolute',
        top: '30%',
        left: '70%',
        width: '20%',
      },
    },
    {
      bcg: require('./5.png'),
      name: 'otoja_kl1_prezentacje',
      title: 'Oto ja, Tablice demonstracyjne, kl. 1',
      router: 'presentations-view',
      disable: true,
      cssStyle: {
        position: 'absolute',
        top: '68.5%',
        left: '30%',
        width: '20%',
      },
    },
    {
      bcg: require('./6.png'),
      name: 'otoja_kl1_spiewnik',
      title: 'Oto ja, Utwory muzyczne, kl. 1',
      router: 'songs-view',
      disable: true,
      cssStyle: {
        position: 'absolute',
        top: '65%',
        right: '30%',
        width: '20%',
      },
    },
  ],
};

let home;
switch (multibookConfig.launcherType) {
  case 'grid':
    home = homeGridStyle;
    break;
  case 'book':
  default:
    home = homeBookStyle;
    break;
}
export default home;
